var path = '/app/webpack/wealthbar/views/admin/demo/index.html.slim';
var html = "<demo></demo>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;